import React from "react";
import { CopyToCliboard } from "@components/CustomTable/helpers";

export const createAttemptDetailsColumns = (translate, setCurrentTooltip, TOOLTIP_TIMEOUT) => [
  {
    accessorKey: "ReconciliationStreamName",
    header: translate("attempt-details.columns.ReconciliationStreamName"),
    size: 180,
    alignment: "left",
  },
  {
    accessorKey: "MatchingSourceName",
    header: translate("attempt-details.columns.DataSourceName"),
    size: 130,
    alignment: "left",
    cell: ({ row }) => {
      return (
        <span className="flex flex-col items-center justify-center group font-normal">
          <span>{row.original.DataAcquisitionName}</span>
        </span>
      );
    },
  },
  {
    accessorKey: "AreaName",
    header: translate("attempt-details.columns.AreaName"),
    size: 130,
    alignment: "left",
  },
  {
    accessorKey: "OutletName",
    header: translate("attempt-details.columns.OutletName"),
    size: 130,
    alignment: "left",
  },
  {
    accessorKey: "TransactionTerminalCode",
    header: translate("attempt-details.columns.TransactionTerminalCode"),
    size: 130,
    alignment: "left",
  },
  {
    accessorKey: "RecordReference",
    header: translate("attempt-details.columns.RecordReference"),
    size: 150,
  },
  {
    accessorKey: "RecordDate",
    header: translate("attempt-details.columns.RecordDate"),
    size: 180,
  },
  {
    accessorKey: "RecordType",
    header: translate("attempt-details.columns.RecordType"),
    size: 150,
    alignment: "left",
  },
  {
    accessorKey: "Attributes",
    header: translate("attempt-details.columns.Attributes"),
    size: 150,
    displayInPopup: true,
    popupCellDisplay: (value) => {
      return (
        <div className="">
          <div
            data-tooltip-id="attributes-tooltip"
            className="relative text-primary-400 font-semibold"
            onMouseOver={() => {
              setCurrentTooltip(value);
            }}
            onMouseOut={() =>
              setTimeout(() => {
                setCurrentTooltip(null);
              }, TOOLTIP_TIMEOUT)
            }
          >
            {"("}
            {value.length}
            {")"}
          </div>
        </div>
      );
    },
    popupContent: (row) => {
      const value = row.Attributes;
      return (
        <div className="relative ">
          <div className="flex dark:text-white flex-col min-w-[400px] transition-all bg-primary-dark text-[#777f9e] text-14 rounded-lg px-[2px] py-[8px] mb-3 opacity-100">
            {value &&
              value.map((attr, index) => (
                <div
                  className="flex flex-row justify-between gap-2 mb-[2px]"
                  key={index}
                >
                  <span className="py-[2px] whitespace-nowrap text-xs font-semibold">
                    {attr.Key}
                  </span>
                  <span className="relative py-[2px] flex gap-2 items-center px-[8px] whitespace-nowrap ltr:text-right rtl:text-left text-sm">
                    {attr.Value}
                    <div className=" absolute left-0 w-full justify-center flex opacity-0 hover:opacity-100 dark:bg-opacity-65 dark:bg-gray-700 bg-gray-300 bg-opacity-50 rounded">
                      <CopyToCliboard size="5" value={attr.Value} />
                    </div>
                  </span>
                </div>
              ))}
          </div>
        </div>
      );
    },
  },
  {
    accessorKey: "PaymentMethod",
    header: translate("attempt-details.columns.PaymentMethod"),
    size: 140,
    alignment: "left",
  },
  {
    accessorKey: "Amount",
    header: translate("attempt-details.columns.Amount"),
    size: 130,
    cell: ({ row }) => {
      const { FormatWithCommas } = require("@helpers/helpers");
      return (
        <span className="flex flex-col items-center justify-center group font-normal">
          <span>{`${row.original.Currency} ${FormatWithCommas(
            row.original.Amount
          )}`}</span>
        </span>
      );
    },
  },
  {
    accessorKey: "InTransitDeadline",
    header: translate("attempt-details.columns.DeadlineDate"),
    size: 130,
  },
];
